{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Transfer to operator",
    "MESSAGE": "Transfer me to an operator"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Uploading..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Submit"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Send message again",
      "ERROR_MESSAGE": "Couldn't send, try again"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Rate the quality of this answer"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Please wait for agent to join"
  },
  "ROBOT_CHECK": {
    "TITLE": "Quick security check",
    "DESCRIPTION": "Please complete the check below.",
    "VERIFYING": "Verifying…",
    "ERROR": "That did not work. Please try again.",
    "RETRY": "Try again"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "We are online",
    "OFFLINE": "We are away at the moment",
    "ONLINE_WITH_BOT": "The team and our AI assistant are online",
    "OFFLINE_WITH_BOT": "Our AI assistant is here to help",
    "BOT_ONLY_REPLY": "Responds immediately"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Typically replies in a few minutes",
    "IN_A_FEW_HOURS": "Typically replies in a few hours",
    "IN_A_DAY": "Typically replies in a day",
    "BACK_IN": "We will be back online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "START_CONVERSATION": "Start Conversation",
  "END_CONVERSATION": "End Conversation",
  "CONTINUE_CONVERSATION": "Continue conversation",
  "YOU": "You",
  "START_NEW_CONVERSATION": "Start a new conversation",
  "RESOLVE_LATER": "We'll resolve this topic via email/phone. I want to ask about something else now.",
  "VIEW_UNREAD_MESSAGES": "You have unread messages",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "See new messages",
    "CLOSE_MESSAGES_BUTTON": "Close",
    "COMPANY_FROM": "from",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chat with us"
  },
  "POWERED_BY": "Powered by {brandName}",
  "EMAIL_PLACEHOLDER": "Please enter your email",
  "CHAT_PLACEHOLDER": "Type your message",
  "TODAY": "Today",
  "YESTERDAY": "Yesterday",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Full Name",
        "PLACEHOLDER": "Please enter your full name",
        "REQUIRED_ERROR": "Full Name is required"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Email Address",
        "PLACEHOLDER": "Please enter your email address",
        "REQUIRED_ERROR": "Email Address is required",
        "VALID_ERROR": "Please enter a valid email address"
      },
      "PHONE_NUMBER": {
        "LABEL": "Phone Number",
        "PLACEHOLDER": "Please enter your phone number",
        "REQUIRED_ERROR": "Phone Number is required",
        "DIAL_CODE_VALID_ERROR": "Please select a country code",
        "VALID_ERROR": "Please enter a valid phone number",
        "DROPDOWN_EMPTY": "No results found",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "Message",
        "PLACEHOLDER": "Please enter your message",
        "ERROR": "Message too short"
      }
    },
    "CAMPAIGN_HEADER": "Please provide your name and email before starting the conversation",
    "IS_REQUIRED": "is required",
    "REQUIRED": "Required",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_FILE_UPLOAD_SIZE} attachment limit",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Invalid field"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Search emojis",
    "NOT_FOUND": "No emoji match your search",
    "ARIA_LABEL": "Emoji picker"
  },
  "CSAT": {
    "TITLE": "Rate your conversation",
    "SUBMITTED_TITLE": "Thank you for submitting the rating",
    "PLACEHOLDER": "Tell us more..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Request a conversation transcript",
    "SEND_EMAIL_SUCCESS": "The chat transcript was sent successfully",
    "SEND_EMAIL_ERROR": "There was an error, please try again"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popular Articles",
    "VIEW_ALL_ARTICLES": "View all articles",
    "IFRAME_LOAD_ERROR": "There was an error loading the article, please refresh the page and try again."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Open",
      "BUY": "Buy"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Picture message"
    },
    "audio": {
      "CONTENT": "Audio message"
    },
    "video": {
      "CONTENT": "Video message"
    },
    "file": {
      "CONTENT": "File Attachment"
    },
    "location": {
      "CONTENT": "Location"
    },
    "fallback": {
      "CONTENT": "has shared a url"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Replying to:"
  }
}
